import { css, jsx } from '@emotion/core';
import React, { useEffect, useState } from 'react';

import Link from '@/src/shared/components/Link';
import Table from '@/src/shared/components/Table';
import { colors } from '@/styles';
import request from '@/utils/axios';

const style = {
  name: css`
    color: ${colors.secondaryBlue};
    font-weight: bolder;
  `,
  sorterText: css`
    font-weight: bolder;
    margin-bottom: 0px;
  `,
};
const NameSort = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetchData = async type => {
    const result = await request({
      url: `profile/staffprofiles?type=${type}`,
    });
    const {
      data: { Profiles },
    } = result;
    setData(Profiles);
    setLoading(false);
  };

  useEffect(() => {
    fetchData('name');
  }, []);

  const columns = [
    {
      title: 'Name',
      dataIndex: 'Name',
      key: 'Name',
      render: (text, record) => {
        return (
          <Link
            anchor
            css={style.name}
            data-attr={record.Name}
            href={`mailto:${record.EmailAddress}`}
          >
            {text}
          </Link>
        );
      },
      width: '250px',
    },
    {
      title: 'Title',
      dataIndex: 'Title',
      key: 'Title',
      width: '240px',
    },
    {
      title: 'Phone',
      dataIndex: 'Phone',
      key: 'Phone',
      render: (text, record) => {
        return (
          <Link anchor data-attr={record.Name} href={`tel:${text}`}>
            {text}
          </Link>
        );
      },
      width: '180px',
    },
  ];
  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        rowKey="PersonId"
        showHeader={false}
        pagination={false}
        scroll={{ x: 670 }}
        css={css`
          .ant-table-row-cell-break-word {
            white-space: normal !important;
          }
        `}
      />
    </>
  );
};

export default NameSort;
